<template>
  <div id="wdbm" class="container">
    <div class="content">
      <div class="box">
        <div class="title">
          <span>{{info.JobName}}</span>
        </div>
        <el-table class="table-xueyuan" :data="[info]">
          <el-table-column label="" width="100">
            <template slot-scope="scope">
              <div class="pic">
                <img :src="scope.row.Pic" />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="姓名/性别/身份证号">
            <template slot-scope="scope">
              <div class="item">
                <div>
                  <span style="color: #333333;font-weight: 600;">{{scope.row.Name}}</span>
                  <span>{{scope.row.Sex==0?'男':'女'}}</span>
                </div>
                <div>
                  <span>{{scope.row.IdNumber}}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="Mobile" align="right" label="完成课时">
            <template slot-scope="scope">
              <div class="item">
                <div>
                  <k-progress :data="{wc:0,hg:scope.row.CompleteLessonCount,zs:scope.row.LessonCount}"></k-progress>
                </div>
                <div class='tj-number'>
                  <span>
                    <span style="color: #16cfd0;">{{scope.row.CompleteLessonCount}}</span>/<span style="color: #777777;">{{scope.row.LessonCount}}</span>
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="" align="center" width="60">
            <template slot-scope="scope">
              <div class="item">
                <div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="开始学习时间" width="200">
            <template slot-scope="scope">
              <div class="item">
                <div>
                  {{scope.row.FirstUpdateProcessTime | dateformat('YYYY-MM-DD HH:mm')}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="最后学习时间" width="200">
            <template slot-scope="scope">
              <div class="item">
                <div>
                  {{scope.row.LastUpdateProcessTime | dateformat('YYYY-MM-DD HH:mm')}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="LastUpdateProcessIP" label="最后学习IP" width="150">
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-table class="table-lesson" :data="info.LessonRecords">
      <el-table-column prop="Name" label="课程名称">
      </el-table-column>
      <el-table-column prop="Teachers" label="讲师" width="120">
      </el-table-column>
      <el-table-column align="right" label="学习进度（秒）" width="130">
        <template slot-scope="scope">
          <div>
            <span style="color: #16cfd0;">{{scope.row.Progress}}</span>/<span>{{scope.row.Duration}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="40">
      </el-table-column>
      <el-table-column label="开始学习时间" width="160">
        <template slot-scope="scope">
          <div class="item">
            <div>
              {{scope.row.FirstUpdateProcessTime | dateformat('YYYY-MM-DD HH:mm')}}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="最后学习时间" width="160">
        <template slot-scope="scope">
          <div class="item">
            <div>
              {{scope.row.UpdateProcessTime | dateformat('YYYY-MM-DD HH:mm')}}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="最后学习IP" width="140">
        <template slot-scope="scope">
          <div class="item">
            <div>
              {{scope.row.UpdateProcessIP}}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="" width="100" header-align="center" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.FirstUpdateProcessTime && scope.row.UpdateProcessTime" class="cell-btn" @click="handleLessonLog(scope.row)">
            <svg t="1569144687887" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1757" width="14" height="14">
              <path d="M269.845 81.43h44.82v166.627h-44.82zM677.14 491.72c52.335 0 102.092 19.937 140.106 56.138 38.126 36.31 60.461 85.284 62.891 137.9 2.506 54.277-16.274 106.28-52.881 146.432-36.607 40.152-86.66 63.644-140.937 66.15-3.18 0.148-6.401 0.222-9.576 0.222-52.341 0-102.102-19.937-140.114-56.137-38.126-36.309-60.461-85.284-62.891-137.902-2.506-54.277 16.274-106.28 52.881-146.432 36.607-40.152 86.66-63.644 140.936-66.15a208.123 208.123 0 0 1 9.576-0.22h0.009m-0.01-44.823c-3.86 0-7.746 0.089-11.642 0.269-136.952 6.324-242.848 122.47-236.525 259.422 6.143 133.056 115.942 236.794 247.78 236.794 3.859 0 7.747-0.089 11.642-0.269 136.952-6.322 242.847-122.47 236.525-259.422-6.144-133.057-115.943-236.799-247.78-236.794z" p-id="1758" fill="#16cfd0"></path>
              <path d="M490.265 891.11a272.361 272.361 0 0 1-32.683-37.37H180.453c-20.912 0-37.927-17.013-37.927-37.925V225.551c0-20.912 17.014-37.927 37.927-37.927H732.8c20.912 0 37.926 17.014 37.926 37.927v215.605a268.605 268.605 0 0 1 44.821 21.463V225.551c0-45.7-37.047-82.746-82.747-82.746H180.453c-45.7 0-82.747 37.047-82.747 82.746v590.264c0 45.7 37.048 82.747 82.747 82.747h317.98a273.587 273.587 0 0 1-8.168-7.451z" p-id="1759" fill="#16cfd0"></path>
              <path d="M770.725 489.616a225.244 225.244 0 0 1 44.821 27.232v-0.214a225.183 225.183 0 0 0-44.82-27.114v0.096z m41.866 288.914H646.82V576.106h44.82V733.71h120.95zM209.55 380.121h498.256v44.822H209.55z m391.131-298.69h44.822v166.626h-44.822z m-193.84 630.743H209.552v44.821h203.865a272.351 272.351 0 0 1-6.573-44.82z m44.1-166.026H209.55v44.821h217.435a268.707 268.707 0 0 1 23.955-44.821z" p-id="1760" fill="#16cfd0"></path>
            </svg>
            &nbsp;学习记录
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { mapGetters, ProjectSettings } from '@/views/base/base.js'
export default {
  name: 'xxksinfo',
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      info: 'getStudyRecordDetails'
    })
  },
  filters: {
    dateformat(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
      if (dataStr === null) {
        return '';
      }
      return moment(dataStr).format(pattern)
    }
  },
  mounted() {
    // let that = this;
    let params = {
      JobId: this.$route.query.JobId,
      Name: this.$route.query.Name,
      IdNumber: this.$route.query.IdNumber
    }
    document.title = params.Name + ' - 学习记录查询 - ' + ProjectSettings.Title;

    this.$store.dispatch('getStudyRecordDetails', params);
  },

  methods: {
    handleLessonLog(row) {
      this.$router.push({ name: 'studylessonlog', query: row })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/list.scss';
.container {
  display: flex;
  flex-direction: column;
  .content {
    .box {
      display: flex;
      flex-direction: column;
      .title {
        margin-top: 70px;
        span {
          font-size: 30px;
          float: left;
          color: #333;
        }
      }
      .main {
        width: 100%;
        margin-top: 60px;
      }
      .table-xueyuan {
        margin-top: 35px;
      }
    }
    .box-process {
      display: flex;
      flex-direction: column;
      > .title {
        margin-top: 70px;
        span {
          font-size: 30px;
          float: left;
          color: #333;
        }
      }
      .main {
        width: 100%;
        margin-top: 30px;
        border: 1px solid #eaeaea;
        > .row {
          line-height: 40px;
          padding: 30px 40px;
          margin: 0px;
          & + .row {
            border-top: 1px solid #eaeaea !important;
          }
          .span-no {
            font-size: 70px;
            margin: 20px 0px 0px 0px;
          }
          .content-sh {
            display: flex;
            flex-direction: column;
            font-size: 16px;
            color: #777777;
            width: 600px;
            .title {
              font-size: 24px;
              color: #333333;
              line-height: 46px;
              display: flex;
              align-items: center;
              .tag {
                padding: 0 4px;
                background-color: #ff6715;
                border-radius: 4px;
                color: #fff;
                font-size: 12px;
                height: 20px;
                line-height: 20px;
                display: inline-block;
                margin-left: 10px;
              }
            }
            .row {
              display: flex;
              align-items: center;
              width: 600px;
              justify-content: space-between;
            }
          }
        }
      }
    }
    .tj-number {
      text-align: right;
      span {
        margin: 0px !important;
      }
    }
    .cell-btn {
      display: flex;
      align-items: center;
      color: #16cfd0;
      cursor: pointer;
    }
  }
  .table-lesson {
    margin-top: 60px;
    .cell-btn {
      display: flex;
      align-items: center;
      color: #16cfd0;
      cursor: pointer;
    }
  }
}
</style>
<style>
#wdbm .el-table__header thead th > div {
  color: #333;
  font-weight: 600;
}
#wdbm .el-table th,
#wdbm .el-table td {
  padding: 18px 0;
}
</style>
<style scoped>
.el-table >>> .el-table__row:hover,
.el-table >>> .el-table__row:focus {
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.16);
}
.el-table >>> .el-table__row {
  transition: 0.3s all ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/views/home/study_record.vue